import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";
import { rgba } from "emotion-rgba";


export const FilledButtonV1 = styled.button<ThemeStyle> `
  border-radius: ${({ theme }: ThemeStyle) => theme.btnV1Radius};
  background-color: ${({ theme }: ThemeStyle) => theme.brandPrimary};
  border: 1px solid ${({ theme }: ThemeStyle) => theme.brandPrimary};
  color: ${({ theme }: ThemeStyle) => theme.white};
  font-weight: 600;
  letter-spacing: 0.25px;
  font-size: 16px;
  &.no-radius {
    border-radius: 0;
  }
  &.h-50 {
    min-height: 50px;
  }
   
&.disabled,
&[disabled] {
  background-color: ${({ theme }: ThemeStyle) => rgba(theme.colors?.surface40, 1)};  // No opacity required
  }
`;
